import scene from "./Scene";
import camera from "./Camera";
import renderer from "./Rendered";
import light from "./Light";
import { useRef, useEffect } from "react";
import gltfLoader from "./gltfLoader";
import * as THREE from "three";
import { gsap } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";


gsap.registerPlugin(ScrollTrigger);

const Template = () => {
  const mountRef = useRef(null);

  useEffect(() => {
    //Data from the canvas
    const currentRef = mountRef.current;
    const { clientWidth: width, clientHeight: height } = currentRef;

    //Scene, camera, renderer
    scene.add(camera);
    scene.add(light)
    camera.position.set(5, 0, 0);
    renderer.setSize(width, height);
    currentRef.appendChild(renderer.domElement);

    const Logo = new THREE.Group();
    camera.lookAt(Logo.position);
    const sizeModel = 0.7;
    gltfLoader.load(
      "./Models/TapeteYugi.gltf",
      (gltf) => {

        Logo.add(gltf.scene);
        Logo.scale.set(sizeModel, sizeModel, sizeModel);
        Logo.position.set(0, 0, 0);
        Logo.rotation.z = -1.58;
        Logo.rotation.x = 1.575;
        Logo.rotation.y = 0;
        scene.add(Logo);
      }
    );


    //Resize canvas

    renderer.setSize(currentRef.clientWidth, currentRef.clientHeight);
    camera.aspect = currentRef.clientWidth / currentRef.clientHeight;
    camera.updateProjectionMatrix();

    const resize = () => {
      renderer.setSize(currentRef.clientWidth, currentRef.clientHeight);
      camera.aspect = currentRef.clientWidth / currentRef.clientHeight;
      camera.updateProjectionMatrix();
    };
    window.addEventListener("resize", resize);

    //Animate the scene
    const animate = () => {

      renderer.render(scene, camera);
      requestAnimationFrame(animate);
    };
    animate();


    let animation = gsap.timeline({
      repeat: 0, yoyo: false,
      scrollTrigger: {
        markers: false,
        trigger: '.last',
        start: 'top',
        end: '+=4000',
        toggleActions: 'restart none none none',
        scrub: true,
        pin: true,
        pinSpacing: true,
      }
    });
    animation.to(Logo.rotation,
      {
        duration: 1,
        y:1
       
      });
    
      animation.to('.learn',
        {
          opacity:1
         
        });
      


    return () => {
      window.removeEventListener("resize", resize);
      currentRef.removeChild(renderer.domElement);
    };
  }, []);

  return (
    <div
      className='three'
      ref={mountRef}
      style={{ minWidth: "320px", maxWith: "100%", height: "1000px" }}
    >  
   
    </div>
  );
};

export default Template;



